export { getScreenName } from "./aopScreenNames";

const mixpanelEvents = {
  SCREEN_LOAD: "screen_load",
  CTA_CLICKED: "cta_clicked",
  FORM_CLICKED: "form_clicked",
  ERROR_TRIGGERED: "error_triggered",
};

export default mixpanelEvents;

export const webFlowEvents = {
  otp: {
    INITIATED: "lead_otp_initiated",
    SUCCESS: "lead_otp_success",
  },
  pan: {
    SUCCESS: "pan_dob_step_success",
  },
  bank: {
    SUCCESS: "bank_details_step_completed",
  },
  eSign: {
    SUCCESS: "esign_step_completed",
    KRA_SUCCESS: "esign_kra_step_completed",
  },
  finalSubmission: {
    SUBMITTED: "account_opening_submitted",
  },
};
